import aidsInfoReducer from "./reducers";
export { default as aidsInfoTypes } from "./types";
export { default as aidsInfoOperations } from "./operations";
export default aidsInfoReducer;
